module.exports = __webpack_public_path__ + "static/media/ufpr.8203ca13.png";